import React, { FC } from 'react';
import { IconButton, Menu, Box } from '@mui/material'; // Import Box
import MobileMenuLinks from './MobileMenuLinks';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon
import { OutterResponsiveMenuBox, InnerResponsiveMenuBox, StyledLink } from '../style';
import whiteLogo from '../../../../media/whiteLogo.png';
import darkLogo from '../../../../media/blackLogo.png';
import '../logoStyles.css';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { openMobileMenu, closeMobileMenu, selectMobileMenuSliceState } from './menuSlice';
import { scrollFn } from '../helper';
import { useThemeContext } from '../../../global/ThemeContext';

const MobileMenu: FC = () => {
  const dispatch = useAppDispatch();
  const menuSelector = useAppSelector(selectMobileMenuSliceState);
  const { anchorElNavSlice } = menuSelector;
  const isMenuOpen = Boolean(anchorElNavSlice);

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleToggleNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (isMenuOpen) {
      dispatch(closeMobileMenu());
      setAnchorElNav(null);
    } else {
      dispatch(openMobileMenu());
      setAnchorElNav(event.currentTarget);
    }
  };

  const handleCloseNavMenu = () => {
    dispatch(closeMobileMenu());
    setAnchorElNav(null);
  };

  const { darkMode } = useThemeContext();

  return (
    <OutterResponsiveMenuBox sx={{ display: { xs: 'flex', md: 'none' } }}>
      <InnerResponsiveMenuBox>
        <IconButton
          size="large"
          aria-label="hamburger menu"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleToggleNavMenu} // Use toggle handler
          color="inherit"
          sx={{
            overflow: 'hidden', // Prevent layout shifts during rotation
            position: 'relative', // Needed for absolute positioning of icons
            width: '48px', // Explicit size (adjust as needed)
            height: '48px', // Explicit size (adjust as needed)
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              transition: 'transform 0.25s ease-in-out, opacity 0.2s ease-in-out', // Faster transition
              transform: isMenuOpen ? 'rotate(90deg)' : 'rotate(0deg)',
              opacity: isMenuOpen ? 0 : 1,
              pointerEvents: isMenuOpen ? 'none' : 'auto', // Prevent interaction when hidden
            }}
          >
            <MenuIcon sx={{ fontSize: '3rem' }} />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              transition: 'transform 0.25s ease-in-out, opacity 0.2s ease-in-out 0.05s', // Faster transition, slight delay on opacity
              transform: isMenuOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
              opacity: isMenuOpen ? 1 : 0,
              pointerEvents: isMenuOpen ? 'auto' : 'none', // Prevent interaction when hidden
            }}
          >
            <CloseIcon sx={{ fontSize: '3rem' }} />
          </Box>
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={Boolean(anchorElNavSlice)}
          onClose={handleCloseNavMenu}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiPaper-root': {
              backgroundColor: darkMode ? '#12152578' : '#ffffffeb',
              textTransform: 'uppercase',
              border: '1px solid #c8c8c852',
              backdropFilter: 'blur(5px)',
              WebkitBackdropFilter: 'blur(5px)',
            },
            mt: '25px',
          }}
        >
          <MobileMenuLinks />
        </Menu>
        <StyledLink to="/" onClick={() => scrollFn('top')} style={{ flexGrow: 1, textAlign: 'right' }}>
          <img alt="urban_equestrian" src={darkMode ? whiteLogo : darkLogo} className="whiteLogoStylesMobile" />
        </StyledLink>
      </InnerResponsiveMenuBox>
    </OutterResponsiveMenuBox>
  );
};

export default MobileMenu;
